"use client";

import { Field, FieldDescription, FieldError, FieldLabel, NumberField } from "@repo/ui/form-fields";
import { useFieldContext } from "@/shared/forms/form-context";

export interface BookingLimitEntry {
  maxPerPeriod: number;
  periodUnit: "d" | "wk";
}

export interface BookingLimitsValue {
  perDay: number | null;
  perWeek: number | null;
}

export interface BookingLimitFieldProps {
  label?: string;
  description?: string;
  disabled?: boolean;
}

export function BookingLimitField({ label, description, disabled }: BookingLimitFieldProps) {
  const field = useFieldContext<BookingLimitsValue>();

  return (
    <Field errors={field.state.meta.errors} isTouched={field.state.meta.isTouched}>
      {label && <FieldLabel>{label}</FieldLabel>}
      {description && <FieldDescription>{description}</FieldDescription>}
      <div className={`grid grid-cols-2 gap-3 ${label ? "mt-1" : ""}`}>
        <div>
          <NumberField
            label="Per day"
            min={1}
            step={1}
            description="Leave empty for no limit"
            value={field.state.value.perDay}
            onChange={(value) =>
              field.handleChange({
                ...field.state.value,
                perDay: value === null ? null : Math.max(1, Math.round(value)),
              })
            }
            onBlur={field.handleBlur}
            disabled={disabled}
          />
        </div>
        <div>
          <NumberField
            label="Per week"
            min={1}
            step={1}
            description="Leave empty for no limit"
            value={field.state.value.perWeek}
            onChange={(value) =>
              field.handleChange({
                ...field.state.value,
                perWeek: value === null ? null : Math.max(1, Math.round(value)),
              })
            }
            onBlur={field.handleBlur}
            disabled={disabled}
          />
        </div>
      </div>
      <FieldError />
    </Field>
  );
}
